import React, { useEffect, useState } from 'react';
import { translate } from '../services/translate';
import { companyService } from '../services/central-api/company';
import FormDropDownPicker from './FormDropDownPicker';
import { UseFormReturn } from 'react-hook-form';
import { StyleProp, TextStyle } from 'react-native';


interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    zIndex: number;
    disabled: boolean;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    required: boolean;
}

function CompanyDropdown({ form, fieldName, zIndex, disabled, labelStyle, required, viewStyle }: Props) {
    const [selectableCompanies, setSelectableCompanies] = useState<{ label: string; value: number; }[]>([]);

    async function getCompanies() {
        try {
            const companies = await companyService.getSimplifiedCompanies();
            setSelectableCompanies(companies.map((company) => {
                return {
                    value: company.id,
                    label: company.name
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getCompanies();
    }, []);

    return <FormDropDownPicker
        label={translate('company')}
        items={selectableCompanies}
        zIndex={zIndex}
        multiple={false}
        disabled={disabled}
        labelStyle={labelStyle}
        viewStyle={viewStyle}
        required={required}
        fieldName={fieldName}
        form={form}
    />;
}

export default CompanyDropdown;
